import { render, staticRenderFns } from "./shortVideoCommerce.vue?vue&type=template&id=d06e17de&scoped=true"
import script from "./shortVideoCommerce.vue?vue&type=script&lang=js"
export * from "./shortVideoCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06e17de",
  null
  
)

export default component.exports